import gql from 'graphql-tag';

export const CREATE_LESSON = gql`
  mutation CreateLesson($input: LessonInput!) {
    createLesson(input: $input) {
      _id
    }
  }
`;

export const UPDATE_LESSON = gql`
  mutation UpdateLesson($input: LessonInputUpdate!, $id: MOID!) {
    updateLesson(input: $input, id: $id)
  }
`;

export const REMOVE_LESSON = gql`
  mutation RemoveLesson($removeLessonId: MOID!) {
    removeLesson(id: $removeLessonId)
  }
`;
